/**
 * Where the recipe page's back arrow goes.
 *
 * Lives outside app/ so jest can reach it; the screen only executes the answer.
 */

export const RECIPES_TAB_PATH = '/(app)/recipes';

export type RecipeDetailBack =
  | { kind: 'pop' }
  | { kind: 'replace'; path: string };

export interface RecipeDetailBackInput {
  /** The `from` param the opener passed, if any. */
  from?: string;
  /** `router.canGoBack()`: the navigator holds the screen that opened this one. */
  canGoBack: boolean;
  /** The last different path the navigation tracker saw (persisted). */
  previousPath: string | null;
}

export function resolveRecipeDetailBack({
  from,
  canGoBack,
  previousPath,
}: RecipeDetailBackInput): RecipeDetailBack {
  // Opened right after adding a recipe, or from a recipe offered on the last
  // onboarding screen (#721), whose route was replaced in the same tick — the
  // history underneath is onboarding, not a place to return to.
  if (from === 'add' || from === 'onboarding') {
    return { kind: 'replace', path: RECIPES_TAB_PATH };
  }
  // The real history. Popping moves the browser back one entry too, so the
  // arrow and the browser's back button agree; replacing left this recipe in
  // the browser history, one browser back away.
  if (canGoBack) {
    return { kind: 'pop' };
  }
  // No history: a shared link, or a tab the phone reloaded. The tracked path
  // is the best guess left, unless it is another recipe.
  if (previousPath && !previousPath.includes('/recipe-detail/')) {
    return { kind: 'replace', path: previousPath };
  }
  // Never a bare router.back() here: with nothing to pop it fell to the first
  // tab, and the cook landed on My Meals.
  return { kind: 'replace', path: RECIPES_TAB_PATH };
}
